import {
  Award,
  Briefcase,
  Building,
  Building2,
  Calendar,
  Check,
  Compass,
  Eye,
  FileText,
  Hammer,
  HardHat,
  Heart,
  Home,
  Key,
  KeyRound,
  Landmark,
  LayoutGrid,
  Lightbulb,
  MapPin,
  Palette,
  Phone,
  Receipt,
  Ruler,
  Scale,
  Shield,
  Sparkles,
  Star,
  Target,
  Trees,
  TrendingUp,
  Users,
  Wrench,
  Zap,
  type LucideIcon,
} from "lucide-react";

/**
 * Curated set of Lucide icons relevant for a real-estate / construction
 * marketing site. Used by the admin "service icon" picker and by the
 * public services renderer.
 */
export const ICON_MAP: Record<string, LucideIcon> = {
  Award,
  Briefcase,
  Building,
  Building2,
  Calendar,
  Check,
  Compass,
  Eye,
  FileText,
  Hammer,
  HardHat,
  Heart,
  Home,
  Key,
  KeyRound,
  Landmark,
  LayoutGrid,
  Lightbulb,
  MapPin,
  Palette,
  Phone,
  Receipt,
  Ruler,
  Scale,
  Shield,
  Sparkles,
  Star,
  Target,
  Trees,
  TrendingUp,
  Users,
  Wrench,
  Zap,
};

export const ICON_NAMES = Object.keys(ICON_MAP);

export function getIcon(name: string | null | undefined): LucideIcon {
  if (!name) return Building2;
  return ICON_MAP[name] ?? Building2;
}
